<template>
  <div style="height: 730px;width:290px;">
    <div v-for="(item,index) in flow" :key="index">
      <div class="flow-item">
        <div class="yuan"></div>
        <div class="line" v-if="evaluation.length?true:index != last"></div>
        <div>
          <div class="flow-header">{{item.title}}</div>
          <div class="text">{{item.time}}</div>
          <div class="text">{{item.name}}{{item.state}}</div>
        </div>
      </div>
    </div>
    <div v-if="evaluation.length">
      <div class="flow-item">
        <div class="yuan"></div>
        <div>
          <div class="flow-header">{{evaluation[0].title}}
          </div>
          <div class="text">{{evaluation[0].time}}</div>
          <div class="text">{{evaluation[0].info}}</div>
          <div class="text">{{evaluation[0].content}}</div>
          <div class="box stars-wrapper">
            <div class="item box" v-for="(item,index) in 5" :key="index">
              <img class="star" v-if="index<=evaluation[0].stars-1" src="../../../assets/images/star1.png"/>
              <img class="star" v-else="index>evaluation[0].stars-1" src="../../../assets/images/star0.png"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      businesskey: String,
      flow: Array,
      evaluation: Array
    },
    data() {
      return {
        //   flow:[{
        //     title:'事件上报',
        //     time:'2018-11-05 10:02',
        //     info:'王丽娟已上报'
        //   },{
        //     title:'事件转派',
        //     time:'2018-11-06 9:00',
        //     info:'蒲瑞祥园社区已派转至物业公司'
        //   },{
        //   title:'事件办理',
        //     time:'2018-11-08 15:30',
        //     info:'物业公司已办理'
        // },{
        //     title:'事件核实',
        //     time:'2018-11-09 8:30',
        //     info:'社区已核实'
        //   },{
        //   title:'事件评价',
        //     time:'2018-11-10 12:20',
        //     info:'王丽娟已上报'
        // }]
      }
    },
    computed: {
      last() {
        return this.flow.length - 1
      }
    }
  }
</script>

<style scoped>
  .flow-item {
    padding-left: 40px;
    padding-bottom: 60px;
    position: relative
  }

  .yuan {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid #2e8de7;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 11;
  }

  .flow-header {
    font-size: 26px;
    color: #505050;
    line-height: 20px;
    padding-bottom: 15px
  }

  .line {
    width: 0px;
    border-left: 1px solid #cecece;
    height: 100%;
    position: absolute;
    left: 10px;
    z-index: 10
  }

  .star {
    height: 40px;
    width: 40px;
  }

  .stars-wrapper {
    margin-top: 5px;
  }

  .text {
    color: #979797;
    font-size: 20px;
  }
</style>
